import React from 'react';

import { MobileDeviceFilter } from './filters';

const DrawerMobileDevicePanel = () => <MobileDeviceFilter />;

export default DrawerMobileDevicePanel;
